<template>
  <div @click="checkSummary" :class="'simulation-card card--' + simulationMsgState.color">
    <div :class="'tag-header tag-header--' + simulationMsgState.color">
      <span class="tag-header__tag"><i v-if="simulationMsgState.icon" :class="simulationMsgState.icon"></i>{{
        simulationMsgState.text }}</span>
      <div class="image-container">
        <img :src="imgUrl" alt="prop-img">
        <p class="broker__name">{{ brokerName }} {{ $t("simulation") }}</p>
      </div>
    </div>
    <div class="simulation-info">
      <span class="simulation-info__text" v-for="(info, i) in simulationInfo" :key="i"><i
          :class="'simulation-info__icon ' + info.icon"></i><b>{{ info.text }}</b></span>
    </div>
    <div class="simulation-progress">
      <div class="profit-target">
        <span><i class="fa-regular fa-circle"></i>{{ $t('profitTarget') }}</span>
        <p>${{ numberWithCommas(profitTarget) }}</p>
      </div>
      <div class="current-profit">
        <span><i class="fa-regular fa-circle"></i>{{ $t('currentProfit') }}</span>
        <p>${{ numberWithCommas(currentProfit) }}</p>
      </div>
      <div class="progress-bar">
        <v-progress-linear rounded :value="progress" height="14"></v-progress-linear>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  name: "SimulationCard",

  props: {
    testId: Number,
    simulationMsgState: Object,
    simulationInfo: Array,
    imgUrl: String,
    currentProfit: Number,
    profitTarget: Number,
    brokerName: String,
    progress: Number
  },

  computed: {

  },

  methods: {
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    checkSummary() {
      if (this.simulationMsgState.text == "Active")
        this.$router.push({ name: 'funding-simulation-summary', params: { testId: this.testId, market: this.brokerName } });
      else
        this.$router.push({ name: 'funding-simulation-feedback', params: { testId: this.testId, market: this.brokerName } });
    }
  }

}
</script>

<style lang="scss">
$simulation-active: #247851;
$simulation-paused: #303740;
$simulation-abandoned: #FF8933;
$simulation-achieved: #247851;
$simulation-failed: #C42A14;

.theme--dark {
  .simulation-card {
    background-color: #232830;
  }
}

.simulation-card {
  background-color: var(--v-cardBackground-base);
  border-radius: 15px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: all ease-in-out 0.1s;
  font-family: "Avenir", sans-serif;
  box-shadow: 5px 5px 20px 0px rgba(0, 0, 0, 0.05);
  border: 1px solid transparent;
  overflow: hidden;

  .tag-header {
    width: 100%;
    display: flex;
    position: relative;
    flex-direction: row;
    height: max-content;
    justify-content: space-between;

    .tag-header__tag {
      text-align: center;
      height: 40px;
      border-top-right-radius: 20px;
      border-bottom-right-radius: 20px;
      padding: 9px 22px;
      color: var(--v-mainWhite-base);
      margin-top: 25px;
    }

    .image-container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 147px;
      height: 91px;
      border-bottom-left-radius: 15px;
      border-left: 1px solid var(--v-mainBlack-base);
      border-bottom: 1px solid var(--v-mainBlack-base);
      background: var(--v-cardBackgroundForLogo-base);

      img {
        width: 100px;
        max-height: 55px;
      }

      .broker__name {
        font-size: 14px;
        color: var(--v-mainBlack-base);
        margin-bottom: 0;
      }
    }

    &.tag-header--active {
      .tag-header__tag {
        background: $simulation-active;
      }
    }

    &.tag-header--paused {
      .tag-header__tag {
        background: $simulation-paused;
      }
    }

    &.tag-header--abandoned {
      .tag-header__tag {
        background: $simulation-abandoned;
      }
    }

    &.tag-header--achieved {
      .tag-header__tag {
        background: $simulation-achieved;
      }
    }

    &.tag-header--failed {
      .tag-header__tag {
        background: $simulation-failed;
      }
    }
  }

  .simulation-info {
    display: flex;
    margin: 25px 16px 25px 16px;
    flex-direction: row;
    justify-content: space-between;
    width: calc(100% - 32px);

    .simulation-info__text {
      font-family: "Avenir", sans-serif;
      font-size: 14px;
      margin-right: 10px;

      i {
        margin-right: 5px;
      }
    }
  }

  .simulation-progress {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin: 0 16px 16px 16px;
    width: calc(100% - 32px);

    .profit-target,
    .current-profit {
      display: flex;
      text-align: start;
      align-items: flex-start;
      flex-direction: column;

      span {
        display: flex;
        align-items: center;
        font-size: 14px;
        color: var(--v-mainBlack-base);


        i {
          color: var(--v-mainGreen-base);
          margin-right: 5px;
        }
      }

      p {
        font-size: 22px !important;
        margin-top: 5px;
        margin-bottom: 5px;
        font-weight: bold;
        color: var(--v-mainBlack-base);
      }
    }

    .profit-target {
      padding-right: 40px;

      span {
        i {
          color: #C3FFE3;
        }
      }
    }

    .progress-bar {
      margin-top: 5px;
      width: 100%;

      .v-progress-linear {
        &.v-progress-linear--rounded {
          border-radius: 10px;
        }
      }

      .v-progress-linear__determinate {
        opacity: 1 !important;
        background-color: var(--v-mainGreen-base) !important;
        border-color: var(--v-mainGreen-base) !important;
      }
    }
  }

  &:hover {
    border: 1px solid #9A9A9A;
    box-shadow: none;
    cursor: pointer;
  }

  &.card--paused,
  &.card--abandoned,
  &.card--failed {
    .simulation-progress {

      .profit-target,
      .current-profit {
        span {

          i {
            color: #9A9A9A;
          }
        }
      }

      .profit-target {
        span {
          i {
            color: #EEEEEE;
          }
        }
      }

      .progress-bar {
        .v-progress-linear {
          .v-progress-linear__background {
            opacity: 1 !important;
            background-color: #EEEEEE !important;
            border-color: #EEEEEE !important;
          }
        }

        .v-progress-linear__determinate {
          opacity: 1 !important;
          background-color: #9A9A9A !important;
          border-color: #9A9A9A !important;
        }

      }

    }

  }

  &.card--achieved {
    .simulation-progress {

      .profit-target,
      .current-profit {
        span {

          i {
            color: #247851;
          }
        }
      }

      .profit-target {
        span {
          i {
            color: #C3FFE3;
          }
        }
      }

      .progress-bar {
        .v-progress-linear {
          .v-progress-linear__background {
            opacity: 1 !important;
            background-color: #247851 !important;
            border-color: #247851 !important;
          }
        }

        .v-progress-linear__determinate {
          opacity: 1 !important;
          background-color: #247851 !important;
          border-color: #247851 !important;
        }

      }

    }

  }
}
</style>